import { useTranslation } from "react-i18next";
import { Reveal } from "../ui/Reveal";
import { HandArrow } from "../ui/decorations";

const steps = [
  { number: "1", titleKey: "how.step1Title", descKey: "how.step1Desc" },
  { number: "2", titleKey: "how.step2Title", descKey: "how.step2Desc" },
  { number: "3", titleKey: "how.step3Title", descKey: "how.step3Desc" },
];

/** Bloco laranja sólido com os 3 passos. */
export function HowItWorks() {
  const { t } = useTranslation("landing");
  return (
    <section id="how" className="py-24 md:py-32 bg-primary-600">
      <div className="max-w-5xl mx-auto px-6">
        <Reveal className="text-center mb-16">
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-extrabold text-white tracking-tight text-balance">
            {t("how.title")}
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-x-16 relative">
          {steps.map((step, i) => (
            <Reveal key={step.number} delay={i * 120} className="relative text-center md:text-left">
              {/* Setinha entre os passos (desktop), centralizada no vão entre as
                  colunas (gap 64px): right = -(gap/2 + largura/2) = -72px. */}
              {i < steps.length - 1 && (
                <HandArrow className="hidden md:block absolute top-4 -right-[72px] w-20 h-10 text-primary-300/70 z-10" />
              )}
              <span
                className="font-display text-7xl font-extrabold text-primary-300/60 leading-none select-none"
                aria-hidden="true"
              >
                {step.number}
              </span>
              <h3 className="font-display text-xl font-bold text-white mt-3 mb-2">{t(step.titleKey)}</h3>
              <p className="text-sm text-primary-100 leading-relaxed max-w-xs mx-auto md:mx-0">
                {t(step.descKey)}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
